import useCreateTaskAssu from '../mutations/useCreateTaskAssu';
import useExportPartyToAssu from '../mutations/useExportPartyToAssu';
import useUploadDocumentsAssu from '../mutations/useUploadDocumentsAssu';

export default function useActionsAssu() {
  const { mutateAsync: createTask } = useCreateTaskAssu();
  const { mutateAsync: exportParty } = useExportPartyToAssu();
  const { mutateAsync: uploadDocuments } = useUploadDocumentsAssu();

  return {
    createTask,
    exportParty,
    uploadDocuments,
  };
}
